import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/Dr-Brand-100x100.png";
import "./FooterStyle.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-logo">
            <img src={logo} alt="Dr Brand Logo" className="logo-img" />
            <p>{t("footer.ali_eldeeb_praise")}</p>
          </div>

          <div className="footer-links">
            <h3>{t("footer.links_title")}</h3>
            <ul>
              <li>
                <a href="#home">{t("nav.home")}</a>
              </li>
              <li>
                <a href="#about">{t("nav.about")}</a>
              </li>
              <li>
                <a href="#Vision&Goals">{t("nav.Vision&Goals")}</a>
              </li>
              <li>
                <a href="#services">{t("nav.services")}</a>
              </li>
              <li>
                <a href="#Testimonials">{t("nav.Testimonials")}</a>
              </li>
              <li>
                <a href="#BookConsultation">{t("nav.contact")}</a>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h3>{t("footer.contact_title")}</h3>
            <address className="contact-list">
              <li>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="contact-icon"
                />
                {t("footer.address")}
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href={`tel:${t("footer.phone")}`} className="phone-link">
                  {t("footer.phone")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href={`tel:${t("footer.phone2")}`} className="phone-link">
                  {t("footer.phone2")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href={`mailto:${t("footer.email")}`} className="email-link">
                  {t("footer.email")}
                </a>
              </li>
            </address>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/share/1HJMUox4Z1/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Page"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://www.instagram.com/dr.brand_ma?igsh=MWd1Zmpuc3I1dmF2aA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Page"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://www.linkedin.com/company/dr-brand-ma/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Linkedin Page"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Dr Brand. {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
